"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebouncedSetState = exports.useDebouncedValue = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactUse = require("react-use");

var useDebouncedValue = function useDebouncedValue(value) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      debouncedValue = _useState2[0],
      setDebouncedValue = _useState2[1];

  var _useDebounce = (0, _reactUse.useDebounce)(function () {
    setDebouncedValue(value);
  }, time, [value]),
      _useDebounce2 = (0, _slicedToArray2["default"])(_useDebounce, 1),
      isReady = _useDebounce2[0];

  return [debouncedValue, isReady];
};

exports.useDebouncedValue = useDebouncedValue;

var useDebouncedSetState = function useDebouncedSetState(initialState) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var _useState3 = (0, _react.useState)(initialState),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

  var _useState5 = (0, _react.useState)(initialState),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      debouncedState = _useState6[0],
      setDebouncedState = _useState6[1];

  (0, _reactUse.useDebounce)(function () {
    setDebouncedState(state);
  }, time, [state]);
  return [debouncedState, setState, state, debouncedState === state];
};

exports.useDebouncedSetState = useDebouncedSetState;